// The order the wizard's step groups render in.
export const STEP_GROUPS = ['required', 'optional'];
